import {
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    Grid,
    Typography,
} from "@mui/material";
import { IconTrash } from "@tabler/icons-react";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { deleteFormField, formFieldDeleteErrorClear } from "store/app/form-management/form-congifuration/actions";
import { ErrorAlert } from "ui-component/custom-components/alertMessage";

const FormFieldDelete = (props) => {

    const { open, handleClose, selectedFieldIndex, fieldsList, updateFields, formFieldDeleteErrorMessage, isFormFieldDeletePending, updateFieldErrors } = props;

    useEffect(() => {
        props.formFieldDeleteErrorClear();
    }, [open])

    const handleDelete = () => {
        const selectedField = fieldsList[selectedFieldIndex];
        const selectedFieldId = selectedField ? selectedField["Id"] : null;
        if (selectedFieldId) {
            props.deleteFormField(selectedFieldId);
        }
        else {
            fieldsList.splice(selectedFieldIndex, 1);
            updateFields(fieldsList);
            handleClose();
        }
        //-----------|| ERROR ||------------//
        let currentErrors = [{}];
        fieldsList?.map((field, index) => {
            if (!field.FieldName || !field.FieldName?.trim()) {
                currentErrors[index] = { ...currentErrors[index], FieldName: "Field name is required" };
            }
            if (!field.DataType || !field.DataType?.trim()) {
                currentErrors[index] = { ...currentErrors[index], DataType: "Data type is required" };
            }
        })
        updateFieldErrors(currentErrors);
    }

    return (
        <>
            <Dialog open={open} maxWidth={'xs'} fullWidth>
                {open && (
                    <>
                        <DialogContent>
                            {formFieldDeleteErrorMessage && <ErrorAlert content={formFieldDeleteErrorMessage} />}
                            <Grid container direction={'column'}>
                                <Grid item sx={{ display: "flex", justifyContent: "center" }}>
                                    <IconTrash size={50} color="#CC2B52" />
                                </Grid>
                                <Grid item sx={{ display: "flex", justifyContent: "center" }}>
                                    <Typography variant="h3">
                                        Are you sure you want to delete this field ?
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container justifyContent={"right"} gap={1} marginTop={2}>
                                <Button
                                    variant="contained"
                                    color='error'
                                    size="small"
                                    onClick={handleClose}
                                >
                                    No,cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    size="small"
                                    onClick={handleDelete}
                                    disabled={isFormFieldDeletePending}
                                >
                                    {isFormFieldDeletePending ?
                                        <Grid item sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <CircularProgress size={'20px'} color='inherit' />
                                            Loading...
                                        </Grid>
                                        : <>Yes, I&apos;m sure</>
                                    }
                                </Button>

                            </Grid>
                        </DialogContent>
                    </>
                )}
            </Dialog >
        </>
    )
}

const mapStateToProps = (state) => ({
    isFormFieldDeletePending: state.formConfiguration.isFormFieldDeletePending,
    formFieldDeleteErrorMessage: state.formConfiguration.formFieldDeleteErrorMessage,
})

const mapDispatchToProps = (dispatch) => ({
    deleteFormField: (selectedFieldId) => dispatch(deleteFormField(selectedFieldId)),
    formFieldDeleteErrorClear: () => dispatch(formFieldDeleteErrorClear()),
})
export default connect(mapStateToProps, mapDispatchToProps)(FormFieldDelete);